<template>
  <Transition name="showPopup">
  <div v-show="visible" class="process-search-popup" :class={open:visible}
    :style="{ left: `${positionX}px`, top: `${positionY}px` }"
    @mousedown="startDragging"
    @mousemove="dragElement"
    @mouseup="stopDragging"
    @mouseleave="stopDragging"  
  >
    <div class="process-search-wrap" :class="{deactive: processDeleteAlert}">
      <h2>재료,목적,장비가 동일한 공정도 노드 검색 [총 {{totalCount}} 개]</h2>
      <ul class="protocol_label_list">
          <span>선택된 프로토콜 : </span>
          <li class="label_01"
              v-for="(targetProtocolTag, index) in targetProtocolTagList"
              :key="index"
              :class="targetProtocolTag['class']"
          >
              <span>{{targetProtocolTag['text']}}</span>
          </li>
      </ul>
      <button class="search-close" @click="hide">닫기</button>
      <div class="search-option" @click="preventDrag" @mousedown="preventDrag">
        <ProcessFieldSelector :options="type" @change="(value)=>selectSearchField=value.value"/>
        <ProcessTargetSelector :options="type" @change="(value)=>selectSearchTarget=value.value"/>
        <span>검색어</span>
        <div class="search-input">
          <input type="text" @keydown="inputEnter" @input="setSearchInputData" :value="searchInputData"/>
        </div>
        <btn-link class="search_btn" :style="{minWidth: '80px'}" @click="pageNo=1; totalPage=0; search();">검색</btn-link>
        <span>재료</span>
        <label class="myProcess">
          <input type="checkbox" class="searchMaterial" v-model="similarMaterial" @change="clear">
        </label>
        <div class="search-input-tag" :style="{'background-color' : !similarMaterial? `whitesmoke`:``}">
          <input type="text" @keydown="inputEnter" @input="setSearchMaterial" :style="{'background-color' : !similarMaterial? `whitesmoke`:``}" :value="searchMaterial" :readonly="!similarMaterial"/>
        </div>
        <span>목적</span>
        <label class="myProcess">
          <input type="checkbox" class="searchPurpose" v-model="similarPurpose" @change="clear">
        </label>
        <div class="search-input-tag" :style="{'background-color' : !similarPurpose? `whitesmoke`:``}">
          <input type="text" @keydown="inputEnter" @input="setSearchPurpose" :style="{'background-color' : !similarPurpose? `whitesmoke`:``}" :value="searchPurpose" :readonly="!similarPurpose"/>
        </div>
        <span>장비</span>
        <label class="myProcess">
          <input type="checkbox" class="searchEquipment" v-model="similarEquipment" @change="clear">
        </label>
        <div class="search-input-tag" :style="{'background-color' : !similarEquipment? `whitesmoke`:``}">
          <input type="text" @keydown="inputEnter" @input="setSearchEquipment" :style="{'background-color' : !similarEquipment? `whitesmoke`:``}" :value="searchEquipment" :readonly="!similarEquipment"/>
        </div>
        <div style="display: inline-flex" class="tooltip_box">
          <span class="tooltip_ico"></span>
          <div class="tooltip_txt">
            <p>
              재료:[금], 목적:[구조측정], 장비:[xps]인 프로토콜에서 검색 시 <br>
              1. 장비에만 체크 후 공백 : <br>
              재료:[금], 목적: [구조측정]인 프로토콜 노드를 가지는 공정도 검색<br>
              (장비는 전체검색)<br>
              2. 장비에만 체크 후 'tem'입력 : <br>
              재료가 [금], 목적: [구조측정]이면서 장비 사전에 'tem'이 포함되어있는 공정도 검색
            </p>
          </div>
        </div>
        <!-- <button class="processRemove" :disabled="this.myProcessAllCheck === 0 ? true : false" @click="processDeleteAlert=true">선택삭제</button> -->
        <div style="display: block; width: 100%">
          <h4 style="font-size: 15px">
            <p>
              ※체크박스 체크 후 공백을 입력 => 전체 검색.
            </p>
            <p>
              ※체크박스 체크 후 검색어 입력 => 검색 텍스트 기반 사전 검색.
            </p>
            <p>
              ※체크박스 해제 시 => 체크한 검색조건(재료 또는 목적 또는 장비)과 동일한 사전 검색
            </p>
          </h4>
        </div>
<!--        <div>
          <h4 style="font-size: 13px">
            <p>
              ex) 재료:'금', 목적:'구조측정', 장비:'xps'인 프로토콜에서 연결할 공정도 검색 시
            </p>
            <p>
              1. 장비에만 체크 후 공백 : 재료:'금', 목적: '구조측정'인 공정도 노드 검색
            </p>
            <p>
              2. 장비에만 체크 후 'tem'입력 : 목적: 구조측정, 장비가 xps이면서 재료 사전에 '은'이 포함되어있는 공정도 검색
            </p>
          </h4>
        </div>-->
      </div>
      <div class="search-table" @click="preventDrag" @mousedown="preventDrag">
        <table class="node-search-result">
          <thead>
            <tr>
              <th>
                  <span>
                      정보확인
                  </span>
              </th>
              <th>생성/수정일</th>
              <th>분야</th>
              <th>공정도명</th>
              <th>작성자</th>
            </tr>
          </thead>
          <tbody v-if="processList.length > 0">
            <tr v-for="(item, index) in processList" @click="selectProcess(index, $event)" :data-list-index="index" 
              :class = "{on: (index === selectedProcessIndex)}" 
            >
              <td @mouseover="setShowProtocolTag(index)"
                  @mouseleave="setShowProtocolTag(null)">
                  <span>
                    <span>
                      <div class="tooltip_box"> <span class="tooltip_ico"></span></div>
                    </span>
                  </span>
                  <div v-show="index === connectProcessTagShowIndex"
                       :style="index === connectProcessTagShowIndex ? 'display : block' : 'display : none'"
                       style="position: absolute;">
                    <ul class="protocol_label_list">
                      <li class="label_01 material" v-if="item['material'] && item['material']?.trim() != 0">
                        <span v-html="item['material']"></span>
                      </li>
                      <li class="label_02 measurement" v-if="item['measurement'] && item['measurement']?.trim() != 0">
                        <span v-html="item['measurement']"></span>
                      </li>
                      <li class="label_04 analysis" v-if="item['analysis'] && item['analysis']?.trim() != 0">
                        <span v-html="item['analysis']"></span>
                      </li>
                      <li class="label_03 equipment" v-if="item['equipment'] && item['equipment']?.trim() != 0">
                        <span v-html="item['equipment']"></span>
                      </li>
                    </ul>
                  </div>
              </td>
              <td>
                <span>{{(item.createdDate || item.createDate) | timeFilter}}</span>
                <span>{{(item.updatedDate || '') | timeFilter}}</span>
              </td>

              <td v-html="item.fieldName"></td>
              <td v-html="item.processName"></td>
              <td>{{item.userName ? item.userName : item.user.userName}}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">
                <div class="nodata_txt">
                  <p>동일한 노드를 갖는 공정도를 찾을 수 없습니다.
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Pagination ref="resultsCount" :pageCnt="pageNo" :pageTotalCnt="totalPage" :size="9" @click="selectPage" @setMethod="getChildMethods"></Pagination>
      <div class="button-wrap" @click="preventDrag" @mousedown="preventDrag">
        <btn-link v-if="type==='process'" :style="{minWidth: '80px'}" @click="processPreview">선택 공정도 미리보기</btn-link>
        <btn-link v-if="type==='process'" :style="{minWidth: '80px'}" @click="connectProcess">선택 공정도에 연결하기</btn-link>
      </div>
    </div>
    <modifyTagLayerPopup
            :active.sync = "modifyTagLayerPopupActive" 
            @setTargetProtocolTag = "setTargetProtocolTag"
    ></modifyTagLayerPopup>
    <Loading :visible="loading"/>
  </div>
  </Transition>
  </template>
  
  <script>
  import CommNew from "@processEditor/CommNew";
  import { createNamespacedHelpers } from 'vuex';
  import {checkProtocolLink} from "@/mixins/makeLinkInfo";
  import ProcessFieldSelector from '../common/selects/FieldSelector.vue'
  import ProcessTargetSelector from '../common/selects/TargetSelector.vue'
  import SortSelector from '../common/selects/SortSelector.vue'
  import Pagination from './Pagination.vue'
  import BtnLink from '../btns/BtnLink.vue'
  import Loading from '../common/loading.vue'
  import modifyTagLayerPopup from '@modal/modifyTagLayerPopup'
  import {v4} from "uuid";

  const ProcessSelector = createNamespacedHelpers('ProcessSearch');
  const ProcessEditor = createNamespacedHelpers('ProcessEditor');
  const Dictionary = createNamespacedHelpers('Dictionary');
  
  export default {
  name: 'process-search',
  mixins : [ CommNew ] , 
  props: {
    type: String,
    searchLinkData : Object,
    overWriteProtocolMode : {
      type : Boolean ,
      default : false ,
    } ,
  },
  beforeDestroy() {
    this.searchInputData = '';
    this.searchMaterial = '';
    this.searchPurpose = '';
    this.searchEquipment = '';
  },
  components: {
      ProcessFieldSelector,
      ProtocolFieldSelector : _=> import( '@common/selects/ProtocolFieldSelector' ) , 
      ProcessTargetSelector,
      Pagination,
      SortSelector,
      BtnLink, Loading,
      modifyTagLayerPopup,
  },
  watch: {
    searchLinkData (value) {
      //최초 호출시 두번호출되는 오류
      /*if( this.visible ) this.selectPage(1);*/
    },
    async visible(value){
      if( value ){
        if (this.beforePreviewFlag != true) {
          await this.initElements();
          this.setTargetProtocolTag();
          this.selectPage(1);
        }
      }
    },
    selected(){
      console.log(this.selected)
    }
  },  
  data () {
    return {
      visible: false,
      processList: [],
      myProcessList: [],
      selected: null,
      pageNo: 1,
      totalPage: 0,
      childMethods:{},
      searchInputData:'',
      selectSearchType : '',
      pageShowCnt: 15,
      selectedProcessIndex: null,
      selectSearchField: 0,
      selectSearchTarget: 'name',
      checkMyProcess: false,
      myProcessAllCheck: 0,
      processDeleteAlert: false,
      loading: false,
      sortBy : 'id, desc',
      isDragging: false,
      offsetX: 0,
      offsetY: 0,
      positionX: 0,
      positionY: 0,
      compareKeyList : ['equipment','measurement','analysis','material'],
      targetProtocolTagList : [],
      totalCount:0,
      registDictionaryPopupOpenFlag: false,
      similarMaterial : true,
      similarPurpose : true,
      similarEquipment : true,
      searchMaterial : '',
      searchPurpose : '',
      searchEquipment : '',

      modifyTagLayerPopupActive: false,
      connectProcessTagShowIndex : null,
      beforePreviewFlag : false,
    }
  },
    computed: {
    ...ProcessSelector.mapState({
      selectedProcess: state => state.selectedProcess
    }) ,
    ...ProcessEditor.mapGetters(['getDiagram']),
  },
  mounted(){
    this.emitInterface();
    this.selectPage(1);
  },
  filters: {
    timeFilter (time) {
      if(time) time = time.replace('T', ' ');
      else time = '';
      return time
    }
  },
    methods: {
      ...ProcessEditor.mapMutations(['selectNode']),
      ...ProcessSelector.mapMutations(['selelctProcess']),
      ...Dictionary.mapActions(
              [
                      "setRegistDictionaryData",
                      "findRegistDataByCategory",
              ]
      ),

      startDragging(event) {
        this.isDragging = true;
        this.offsetX = event.clientX - event.currentTarget.getBoundingClientRect().left;
        this.offsetY = event.clientY - event.currentTarget.getBoundingClientRect().top;
      },
      dragElement(event) {
        if (this.isDragging) {
          this.positionX = event.clientX - this.offsetX;
          this.positionY = event.clientY - this.offsetY;
        }
      },
      stopDragging() {
        this.isDragging = false;
      },
      preventDrag(event) {
        event.stopPropagation();
      },

      sortSet(value) {
        this.sortBy = value;
        this.pageNo = 1;
        this.totalPage = 0;
        this.search();
      },

      getChildMethods(methods) {
        this.childMethods = methods;
      },
      emitInterface() {
        this.$emit('setMethod', {show: this.show, hide: this.hide});
      },
      selectProcess(index, event) {
        this.selectedProcessIndex = index;
        this.selected = this.processList[index];
        this.$emit('select-process', this.selected);
      },
      async selectPage(index) {
        this.pageNo = index;
        this.selectedProcessIndex = null;
        this.selected = null;
        await this.search();
        return
      },
      hide(beforePreviewFlag) {
        if(beforePreviewFlag == true){
          this.visible = false;
        }else {
          this.selectedProcessIndex = null;
          this.selected = null;
          this.visible = false;
          this.searchMaterial = '';
          this.searchPurpose = '';
          this.searchEquipment = '';
          this.similarMaterial = true;
          this.similarPurpose = true;
          this.similarEquipment = true;
        }
      },
      show(beforePreviewFlag) {
        if(beforePreviewFlag == true){
          this.beforePreviewFlag = beforePreviewFlag;  
        }else{
          this.beforePreviewFlag = false;
        }
        this.visible = true;
        // this.selectPage(1);
      },

      async search() {
        if (!this.visible) return;
        if (this.type === 'onlyProtocol' && this.searchLinkData.keyOfProtocol == undefined) return;

        this.loading = true
        try {
          const searchType = this.searchType();
          let updateResponse = await this.$wApi.protocol.nodeUpdate({protocolId : this.$route.query.protocolId});
          let response = await this.$wApi.process.release.releaseProtocolMatchSearch(searchType);
          this.totalCount = response?.totalElements;
          const processList = []
          /** 로그 등록 */
          await this.$wApi.trace.log({
            type: this.type === 'process' ? 'PD' : 'PR', //PD 공정도, PR 프로토콜
            code: 'S', //N 생성 M 수정 S 검색 R 조회
            subCode: '01',
            keyword: this.searchInputData,
            result: response.content.length ?? 0,
            ptlId: 0
          });
          /** 로그 등록 */

          // console.log( "response.content", response )
          for (let item of response.content) {
            processList.push(item)
          }

          this.processList = processList;
          this.totalPage = response.totalPages;
          // this.pageNo = 0;
          this.loading = false
        } catch (error) {
          // console.log( "error", error)
          this.loading = false
        }
      },

      inputEnter(event) {
        if (event.code === 'Enter' || event.keyCode === 13) {
          this.pageNo = 1;
          this.totalPage = 0;
          this.search();
        }
      },
      async processPreview() {
        if (!this.selected) {
          window.alert('미리보기 할 공정도를 선택해주세요.');
          return;
        }
        this.$emit('process-preview', this.selected);
      },

      processCheck(event) {
        // myProcessAllCheck
        const index = event.currentTarget.dataset.index
        const item = this.processList[index]
        if (event.currentTarget.checked === true) {
          this.myProcessAllCheck++
        } else {
          this.myProcessAllCheck--
        }
        item.checked = event.currentTarget.checked
        this.myProcessAllCheck = Math.max(0, this.myProcessAllCheck)
        this.myProcessAllCheck = Math.min(this.myProcessList.length, this.myProcessAllCheck)

        // console.log('Process check : ', this.myProcessAllCheck, this.myProcessList.length)
      },
      allCheck(e) {
        if (e.currentTarget.checked === false) {
          this.myProcessAllCheck = 0;
        } else {
          this.myProcessAllCheck = this.myProcessList.length;
        }
        for (const item of this.myProcessList) {
          item.checked = e.currentTarget.checked;
        }
      },
      searchType() {
        let searchProperty = {
          query: this.searchInputData,
          protocolId: this.$route.query.protocolId,
          searchTarget: this.selectSearchTarget,
          pageNo: this.pageNo,
          perPage: this.pageShowCnt,
          orderBy: "latest", //추후 옵션으로 이동
          fieldId: this.selectSearchField === 0 ? null : this.selectSearchField,
          isMyData: this.checkMyProcess ? 1 : 0,
          searchConditionMap : {
            query:this.searchInputData,
            searchMaterial:this.searchMaterial? this.searchMaterial.trim() : "",
            searchPurpose:this.searchPurpose? this.searchPurpose.trim() : "",
            searchEquipment:this.searchEquipment? this.searchEquipment.trim() : "",
            similarMaterial: this.similarMaterial,
            similarPurpose: this.similarPurpose,
            similarEquipment: this.similarEquipment,
          }
        }

        // console.log("searchProperty", searchProperty )
        return searchProperty;
      },
      setSearchInputData(e) {
        if (!(e.code === 'Enter' || e.keyCode === 13)) {
          this.searchInputData = e.target.value;
        }
      },
      setSearchMaterial(e) {
        if (!(e.code === 'Enter' || e.keyCode === 13)) {
          this.searchMaterial = e.target.value;
        }
      },
      setSearchPurpose(e) {
        if (!(e.code === 'Enter' || e.keyCode === 13)) {
          this.searchPurpose = e.target.value;
        }
      },
      setSearchEquipment(e) {
        if (!(e.code === 'Enter' || e.keyCode === 13)) {
          this.searchEquipment = e.target.value;
        }
      },

      async connectProcess() {
        if (!this.selected) {
          window.alert('연결 할 공정도를 선택해주세요.');
          return;
        }
        const checkDictionaryFlag = await this.checkDictionary();
        if(checkDictionaryFlag) {
          let connectFlag = 1; //연결
          const confirmResult = await confirm("해당 공정도에 연결하시겠습니까?");
          if (confirmResult) {
            try {
              this.loading = true;
              //연결 중복 방지.
              const duplicateCheck = await this.$wApi.protocol.duplicateCheck({
                protocolId: this.$route.query.protocolId, // 연결하고자 하는 원본 only_protocol의 id
                processId: this.selected.processId, // 연결하고자하는 process ID
                keyOfProtocol: this.selected.keyOfProtocol, // 연결하고자하는 process의 keyOfProtocol
              });

              if (!duplicateCheck) {
                alert('이미 연결된 프로토콜입니다.')
                return;
              }

              //연결
              let response = await this.$wApi.protocol.connect({
                protocolId: this.$route.query.protocolId, // 연결하고자 하는 원본 only_protocol의 id
                processId: this.selected.processId, // 연결하고자하는 process ID
                keyOfProtocol: this.selected.keyOfProtocol, // 연결하고자하는 process의 keyOfProtocol
                connectFlag: 1, // 연결
              });

              if (response.originProtocolId) {
                location.reload();
              } else {
                window.alert("공정도에 프로토콜 연결 중 에러가 발생하였습니다.");
              }
            } catch (e) {
              console.log(e);
            } finally {
              this.loading = false
            }
          }
        }else{
          this.modifyTagLayerPopupActive = true;
        }
      },

      setTargetProtocolTag() {
        const {protocols} = this.PROCESS_INFO;
        const crntProtocol = protocols.filter(o => o.id == this.$route.query.protocolId)[0];
        let tempList = [];
        this.compareKeyList.forEach(key => {
          let className = "";
          let index = 0;
          switch (key) {
            case "material":
              className = "label_01";
              index = 0;
              break;
            case "measurement":
              className = "label_02";
              index = 1;
              break;
            case "analysis":
              className = "label_04";
              index = 1;
              break;
            case "equipment":
              className = "label_03";
              index = 2;
              break;
          }
          if (crntProtocol[key] && crntProtocol[key].trim() != '') { // 데이터가 존재할때만
            let targetProtocolTag = {};
            targetProtocolTag['text'] = crntProtocol[key];
            targetProtocolTag["index"] = index;
            targetProtocolTag["class"] = className;
            tempList.push(targetProtocolTag);
          }
        });

        this.targetProtocolTagList = [];
        this.targetProtocolTagList = tempList.sort(function (a, b) {
          if (a.index > b.index) return 1;
          if (a.index === b.index) return 0;
          if (a.index < b.index) return -1;
        });
      },
      async checkDictionary() {
        const {protocols} = this.PROCESS_INFO;
        const crntProtocol = protocols.filter(o => o.id == this.$route.query.protocolId)[0];
        
        let dataObj = {};
        dataObj.targetProcessId = this.selected.processId;
        dataObj.targetkey = this.selected.keyOfProtocol;
        dataObj.correctionTargetProcessId = crntProtocol.onlyProtocolProcessId;
        dataObj.correctionTargetKey = crntProtocol.keyOfProtocol;
        await this.setRegistDictionaryData(dataObj);
        
        let material = await this.findRegistDataByCategory({category:"MATERIAL"});
        let analysis = await this.findRegistDataByCategory({category:"ANALYSIS"});
        let measurement = await this.findRegistDataByCategory({category:"MEASUREMENT"});
        let equipment = await this.findRegistDataByCategory({category:"EQUIPMENT"});
        
        if(measurement.registTypeError || analysis.registTypeError){
          return false;
        }
        
        let api = this.$wApi;
        let selectedData = this.selected; 

        async function callDictionaryApi(data) {
          let correctionTargetDictionary = await api.dictionary.getDictionaryByKey({
            processId: crntProtocol.onlyProtocolProcessId,
            key: data.correctionTargetProcessNode.key,
            tagId: data.correctionTargetProcessNode.tagId,
          });
          let targetDictionary = await api.dictionary.getDictionaryByKey({
            processId: selectedData.processId,
            key: data.targetProcessNode.key,
            tagId: data.targetProcessNode.tagId,
          });

          if (correctionTargetDictionary.id && targetDictionary.id) {
            if (correctionTargetDictionary.id == targetDictionary.id) {
              return true;
            } else {
              // 양쪽 확인.
              if(targetDictionary.similarTagList.filter(inData => inData.tagId == data.correctionTargetProcessNode.tagId).length == 0
                  && correctionTargetDictionary.similarTagList.filter(inData => inData.tagId == data.targetProcessNode.tagId).length == 0){
                for(const targetTag of targetDictionary.similarTagList){
                  for(const correctionTag of correctionTargetDictionary.similarTagList){
                    if(targetTag.tagId == correctionTag.tagId){
                      return true;
                    }
                  }
                }
                return false;
              }else{
                return true;
              }
            }
          } else if (!correctionTargetDictionary.id && targetDictionary.id) { // 둘 중 한개만 있을때
            if (targetDictionary.similarTagList.filter(inData => inData.tagId == data.correctionTargetProcessNode.tagId).length == 0) { // tagId가 포함되어 있는지 확인.
              return false;
            } else {
              return true;
            }
          } else if (correctionTargetDictionary.id && !targetDictionary.id) { // 둘 중 한개만 있을때
            if (correctionTargetDictionary.similarTagList.filter(inData => inData.tagId == data.targetProcessNode.tagId).length == 0) { // tagId가 포함되어 있는지 확인.
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        }
        
        if(material.correctionTargetProcessNode.tagId != material.targetProcessNode.tagId){
          const checkDictionary = await callDictionaryApi(material); 
          if(!checkDictionary){
            return false;  
          }
        }
        if(equipment.correctionTargetProcessNode.tagId != equipment.targetProcessNode.tagId){
          const checkDictionary = await callDictionaryApi(equipment); 
          if(!checkDictionary){
            return false;  
          }
        }
        if(analysis.registFlag){
          if(analysis.correctionTargetProcessNode.tagId != analysis.targetProcessNode.tagId){
            const checkDictionary = await callDictionaryApi(analysis); 
            if(!checkDictionary){
              return false;  
            }
          }
        }else if (measurement.registFlag){
          if(measurement.correctionTargetProcessNode.tagId != measurement.targetProcessNode.tagId){
            const checkDictionary = await callDictionaryApi(measurement); 
            if(!checkDictionary){
              return false;  
            }
          }
        }

        
        return true;
      },
      clear(e){
        this[e.target.className] = "";
      },
      setShowProtocolTag(dataIndex) {
        this.connectProcessTagShowIndex = dataIndex;
      },
    }
  }
  </script>
  
<style lang="scss">
  .showPopup-enter-active {
    visibility: hidden;
    backdrop-filter: blur( 0px ); 
    transition: visibility 0.475s , backdrop-filter 0.475s; 
  
    .process-h-wrap {
      opacity: 0;
      transform: scale(0);
      transition-property: transform , opacity; 
      transition-duration: 0.475s , 0.475s; 
      transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);
    }
  }
  .showPopup-leave-active {
    transition: visibility 0.475s , backdrop-filter 0.475s; 
    .process-search-wrap {
      transition-property: transform , opacity; 
      transition-duration: 0.475s , 0.475s; 
      transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);
    }
  }
  .showPopup-enter-to {
    visibility: visible;
    // backdrop-filter: blur( 2px ); 
  
    .process-search-wrap {
      opacity: 1;
      transform: scale(1);
    }
  }
  .showPopup-leave-to {
    visibility: hidden;
  
    .process-search-wrap {
      opacity: 0;
      transform: scale(0);
    }
  }
  
  .process-search-popup {
    display: flex; width: 100%; height: 100%;
    align-items: center; justify-content: center;
    position: fixed; top:0; left:0; right:0; bottom: 0;
    z-index: var(--popup-index-max);
    // backdrop-filter: blur( 2px ); 
  }
  .process-search-wrap {
    $padding: 24px;
    display: grid;
    grid-template:
      'title' auto
      'tag' auto
      'search' auto
      'result' 1fr
      'pagination' auto
      'buttons' auto /
      1fr
    ;
    position: relative;
    max-width: 1110px;
    width:1110px;
    max-height: 90%;
    padding: $padding;
    background-color: #fff;
    border: 1px solid $gray-9; 
    box-shadow: 0px 4px 16px rgba(91, 91, 91, 0.3);
    
    h2 {
      grid-area: title;
      margin: 0 0 24px 0;
      font-size: 20px;
      @include text-prt-sb;
    }
    .search-close {
      $size: 30px;
      $centerPos: $padding - (($size - 14) /2);
      position: absolute; top: $centerPos; right: $centerPos;
      width: $size; height: $size;
      background: url('../../assets/icons/icon-close.svg') center no-repeat;
      font-size: 0;
      cursor: pointer;
    }
    .search-option {
      grid-area: search;
      display: flex; align-items: center;
      flex-wrap : wrap;
      gap: 8px;
      & > span {
        display: inline-block;
        @include text-prt-sb;
        margin: 0 0px 0 16px;
      }
      z-index: 2;
    }
    .data-select {
      min-width: 120px; height: 32px;
      border: 1px solid #999;
      border-radius: 4px;
      color: #666;
  
      datalist {
        border-radius: 4px;
      }
    }
    input[type='checkbox'] {
      width: 18px; height: 18px;
      border: 2px solid #999;
      margin-right: 10px;
      appearance: none;
      background-size: 18px;
      
      &:checked {
        background: url('../../assets/icons/icon-check-circle.svg') center no-repeat #fff;
        border-color: #333;
        border-width: 3px;
      }
    }
    .search-input {
      display: inline-flex; align-items: center;
      width: 600px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid #999;
      input {
        flex-shrink: 2;
        width: 100%;
        border: 0;
        padding: 0 10px;
      }
      button {
        flex-shrink: 0;
        width: 40px; height: 100%;
        font-size: 0;
        background: url('../../assets/icons/magnify.svg') right 10px center no-repeat;
      }
    }
    .search-input-tag {
      display: inline-flex; align-items: center;
      width: 200px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid #999;
      input {
        flex-shrink: 2;
        width: 100%;
        border: 0;
        font-size: 13px;
        padding: 0 10px;
      }
      button {
        flex-shrink: 0;
        width: 40px; height: 100%;
        font-size: 0;
        background: url('../../assets/icons/magnify.svg') right 10px center no-repeat;
      }
    }
    .myProcess {
      display: flex; align-items: center;
      margin-left: 16px;
      cursor: pointer;
      @include text-prt-sb; 
      
    }
    .search-table {
      grid-area: result;
      position: relative;
      margin: 32px 0 0;
      overflow: auto;
      @include scrlbar;
      >font {
        font-size: 14px;
      }
    }
    .node-search-result {
      border-collapse: separate;
      thead {
        position: sticky; top:0;
        background-color: #fff;
        th {
          height: 35px;
          border-bottom: 1px solid #333;  
          text-align: center; vertical-align: middle;
          font-size: 14px;
          @include text-prt-sb;
          &:nth-child(1) {width: 100px;}
          &:nth-child(2) {width: 200px;}
          &:nth-child(3) {width: 220px;}
          &:nth-child(4) {width: 585px;}
          &:nth-child(5) {width: 100px;}
        }
      }
      tbody {
        tr {
          cursor: pointer; 
          &:hover, &.on { background-color: #E8F6F7;}
        }
        td {
          min-height: 40px;
          padding: 8px 5px;
          border-bottom: 1px solid #ddd;
          vertical-align: middle;
          text-align: center;
          font-size: 14px; color: #333;
          @include text-prt-sb;
          line-height: 1.4em;
          &:nth-child(4) {text-align: left;}
          &:nth-child(3) {text-align: left;}
  
          span {
            display: inline-block;
            &:first-child {
              color: #999;
            }
          }
          input {
            vertical-align: middle;
          }
        }
      }
      
    }
    &.deactive {
      &:after {
        content:'';
        display: block;
        position: absolute; top:0; left:0; right:0; bottom:0;
        background-color: rgba(0,0,0, .5);
        z-index: 2;
      }
    }
  }
  .pagination {
    grid-area: pagination;
    margin: 24px 0;
  }
  .button-wrap {
    grid-area: buttons;
    display: flex; align-items: center; justify-content: center;
    gap: 8px;
  }
  .processRemove {
    min-width: 62px;
    padding: 8px;
    margin-left: auto;
    border: 1px solid #ddd;
    border-radius: 3px;
    background-color:#eee;
    font-size: 12px;
  }
  .alertPopup {
    .title {
      margin-bottom: 6px;
    }
    .content {
      font-size: 12px;
      line-height: 24px;
      color: #999;
    }
    .buttons-wrap {
      display: flex; justify-content: center; gap: 8px;
      margin-top: 14px;
    }
  }
  
  @keyframes contentShow {
    0% { transform: translate(0, -20%) }
    100% { transform: translate(0, 0) }
  }
  </style>